
const backControl = require('../../js/back-control')
const string      = require('../../js-handler/string')
const dialog      = require('../dialog/dialog')


/****************ELEMENTS*****************/
const   drawer  = { html : ''}
var     scrimDrawer

var HTMLwasSelected = false
/** Snapshot from last generator() for preview / profile actions */
var drawerUserSnapshot = null
function HTMLselect(){ //console.log('HTMLselect')

   drawer.html      = document.querySelector('#drawer')
   scrimDrawer      = document.getElementById('scrim_drawer')

    HTMLwasSelected  = true
}
/****************ELEMENTS*****************/


export function start(detail){ //console.log('drawer start >', detail)
    
    if(!HTMLwasSelected) {HTMLselect()}
    
    switch (detail.act){
        case 'show':          show();               break; 
        case 'hide':          hide();               break; 
        case 'generator':     generator(detail.data);               break; 
        case 'previewAvatar': previewAvatar();      break; 

    }
}

function generator(data) {

    drawerUserSnapshot = data || null

    // console.log(data)

    const title = drawer.html.querySelector('.header .title')
    const des = drawer.html.querySelector('.header .des')
    const avatarD = drawer.html.querySelector('.avatarD')

    title.innerHTML = string.capitalizeFirstLetter(data.company)
    des.innerHTML = string.capitalizeFirstLetter(`${data.name} - ${data.right}`)
    if (data.avatar != '') {
        avatarD.style.backgroundImage = `url('${data.avatar}')`;
    }

    if (data.entity != 'users') {
        let datadetail = `{"click":[
        {"dest":"ripple"},
        {"dest":"drawer","act":"hide"},
        {"dest":"${data.entity}","elem":"fullcont","id":"${data.entity}-fullcont","act":"selectOne","dbid":"${data.id}"}]}`;
        drawer.html.querySelector('.profield').setAttribute('data-detail', datadetail);
    }

    //data-detail='{"click":[{"dest":"dt", "act":"checkboxTd"}]}'

}/*show*/


function extractBackgroundImageUrl(el) {
    if (!el) return ''
    const raw = el.style && el.style.backgroundImage
        ? el.style.backgroundImage
        : window.getComputedStyle(el).backgroundImage
    if (!raw || raw === 'none') return ''
    const m = raw.match(/url\(\s*["']?([^"')]+)["']?\s*\)/)
    return m ? m[1].trim() : ''
}


function previewAvatar() {
    if (!HTMLwasSelected) HTMLselect()

    const avatarD = drawer.html.querySelector('.avatarD')
    const titleEl = drawer.html.querySelector('.header .title')
    const desEl = drawer.html.querySelector('.header .des')

    let src = extractBackgroundImageUrl(avatarD)
    if (!src && drawerUserSnapshot && drawerUserSnapshot.avatar) {
        src = String(drawerUserSnapshot.avatar)
    }

    const title = titleEl ? titleEl.textContent.trim() : ''
    const des = desEl ? desEl.textContent.trim() : ''
    const uid = drawerUserSnapshot && drawerUserSnapshot.id != null
        ? String(drawerUserSnapshot.id)
        : ''

    hide()

    const bodyHtml = src
        ? `<div class="drawer-avatar-preview"><img src=${JSON.stringify(src)} alt="" /></div>`
        : ''

    const openProfileDetail = uid !== ''
        ? `data-detail='${JSON.stringify({
            click: [
                { dest: 'ripple' },
                { dest: 'dialog', act: 'hide' },
                { dest: 'myuser', elem: 'fullcont', id: 'myuser-fullcont', act: 'selectOne', dbid: uid }
            ]
        })}'`
        : ''

    setTimeout(() => {
        dialog.start({
            act: 'show',
            html: {
                title: title || 'Profile',
                des: des,
                bodyHtml: bodyHtml,
                primary: uid !== ''
                    ? { text: 'Open profile', class: 'button primary', dataDetail: openProfileDetail }
                    : { text: '', class: '', dataDetail: '' },
                secondary: {
                    text: 'Close',
                    class: 'button secondary button-plain',
                    dataDetail: `data-detail='{"click":[{"dest":"ripple"},{"dest":"dialog","act":"hide"}]}'`
                },
                tertiary: { text: '', class: '', dataDetail: '' }
            }
        })
    }, 120)
}


function show(){ //console.log('drawer show>')
    
    drawer.html.classList.add('drawer-anime')
    drawer.html.classList.add('drawer-show')
    drawer.html.setAttribute("style", `left: 0px`)

    scrimDrawer.classList.add('scrim-show')

    //add to the url
    backControl.hashAdd({ toShow:`drawer` })

}/*show*/



function hide() { //console.log('drawer hide >')
  
  //remove to the url
  backControl.hashSub({ toHide:`drawer` })

    remove(()=>{
        scrimDrawer.classList.remove('scrim-show')
        scrimDrawer.setAttribute('data-serving', '')

        drawer.html.classList.add("drawer-anime")
        drawer.html.classList.add("drawer-hide")
        drawer.html.setAttribute("style", `left: -${drawer.html.clientWidth}-50px`)

        drawer.html.classList.remove('drawer-show')
        drawer.html.classList.remove('drawer-hide')

         //console.log('drawer show 123456>', drawer.html)
         
    }) 

}/*hide*/


function remove(callback){
  setTimeout(()=>{ callback() }, 100)
}


